import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Line } from "react-chartjs-2";
import type { DashboardStatsHistoryBucket } from "../../types/stats";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    },
    y: {
      beginAtZero: true,
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    }
  },
  plugins: {
    legend: { display: false }
  }
};

type Props = {
  buckets: DashboardStatsHistoryBucket[];
};

// Daily average online player count (see stats.service.ts on the API side -
// averaged per day rather than a single snapshot, so the line reflects the
// day's typical population instead of one arbitrary sample).
const OnlinePlayersChart = ({ buckets }: Props) => {
  return (
    <Line
      options={options}
      data={{
        labels: buckets.map(b => new Date(b.day).toLocaleDateString()),
        datasets: [
          {
            label: "Avg players online",
            data: buckets.map(b => b.count ?? null),
            borderColor: "#98d8ff",
            backgroundColor: "rgba(152, 216, 255, 0.15)",
            fill: true,
            spanGaps: true,
            tension: 0.2
          }
        ]
      }}
    />
  );
};

export default OnlinePlayersChart;
